export default {"src":"/_next/static/media/KYB_ACTIVE_ICON.21e2e144.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};